import { SVGProps } from 'react';

const Share = ({
  width = 17,
  height = 17,
  fill = '#2A2A2A',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17  17"
    {...otherProps}>
    <path
      d="M3.1733 3.81108H4.27622C4.77842 3.81108 5.18559 3.40395 5.18559 2.90171C5.18559 2.39935 4.77846 1.99234 4.27622 1.99234L3.1733 1.99219C1.42053 1.99265 0.000473404 3.41256 0 5.16549V13.6261C0.000462318 15.3788 1.42053 16.7987 3.1733 16.7992H11.6339C13.3867 16.7991 14.8066 15.3788 14.807 13.6261V12.5232C14.807 12.0208 14.3999 11.6136 13.8975 11.6136C13.3951 11.6136 12.988 12.0208 12.988 12.5232V13.6261C12.9866 14.3736 12.3813 14.9788 11.6337 14.9803H3.17354C2.426 14.9788 1.82067 14.3736 1.81929 13.6261V5.16549C1.82068 4.41779 2.42576 3.81262 3.1733 3.81108Z"
      fill={fill}
    />
    <path
      d="M5.59763 11.1812C5.95284 11.5362 6.52886 11.5362 6.88379 11.1812L14.9593 3.10532V6.69661C14.9593 7.19881 15.3664 7.60614 15.8688 7.60614C16.3712 7.60614 16.7783 7.19869 16.7783 6.69661V0.909511C16.7783 0.791314 16.7544 0.673733 16.709 0.56309C16.6635 0.452598 16.597 0.351045 16.5119 0.266136C16.4268 0.181227 16.3254 0.114654 16.2152 0.0693458C16.1043 0.0238872 15.9865 0 15.8684 0H10.0816C9.57929 0 9.17212 0.407127 9.17212 0.909527C9.17212 1.41173 9.57925 1.81905 10.0816 1.81905L13.6729 1.8189L5.59746 9.89438C5.24225 10.2499 5.24243 10.8257 5.59763 11.1812Z"
      fill={fill}
    />
  </svg>
);

export default Share;
